export default __webpack_public_path__ + "dfb58804d67c7207ab2ad0771ed995f4.svg";